import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnvil: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnvil"><Path d="M20.5 4.5H1.5V8L7.65085 10.4603C8.46569 10.7863 9 11.5755 9 12.4531C9 13.3769 8.40886 14.197 7.53246 14.4892L4.5 15.5V19.5H20.5V15.5L17.423 14.4743C16.5732 14.1911 16 13.3958 16 12.5C16 11.6042 16.5732 10.8089 17.423 10.5257L20.5 9.5V4.5Z" stroke="currentColor"/><Path d="M6.5 4.5V10" stroke="currentColor"/></CentralIconBase>;
});

export default IconAnvil;
